import { render, staticRenderFns } from "./StationSupportContactsForm.vue?vue&type=template&id=2a7aad8b&scoped=true"
import script from "./StationSupportContactsForm.vue?vue&type=script&lang=ts"
export * from "./StationSupportContactsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7aad8b",
  null
  
)

export default component.exports